// extracted by mini-css-extract-plugin
export var X5 = "newFooter-module--X5--LjLJf";
export var actionPassport = "newFooter-module--actionPassport--eqgEY";
export var block = "newFooter-module--block--dHZB+";
export var button = "newFooter-module--button--NRhyB";
export var cookie = "newFooter-module--cookie--h689I";
export var description = "newFooter-module--description--gLlVg";
export var footer = "newFooter-module--footer--jdgmC";
export var hide = "newFooter-module--hide--FXUVG";
export var info = "newFooter-module--info--EZmYZ";
export var redButton = "newFooter-module--redButton--W55NH";
export var seoPromo = "newFooter-module--seoPromo--1F8K1";
export var sticker = "newFooter-module--sticker--uZRMK";
export var text = "newFooter-module--text--aTawy";
export var websitePolicy = "newFooter-module--websitePolicy--ZEQ2J";
export var withoutExpandedBtn = "newFooter-module--withoutExpandedBtn--TnDhO";
export var wrapperLarge = "newFooter-module--wrapperLarge--wrxNT";
export var wrapperSmall = "newFooter-module--wrapperSmall--VZu+e";